import BaseModel from "../core/BaseModel";
export default class PositionModel extends BaseModel {
  constructor() {
    super(
      {
        name: "position",
        tableName: "position",
        label: "Quản Lý Chức Vụ",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Number",
          label: "ID",
          primaryKey: true,
          display: false,
        },

        name: {
          name: "name",
          type: "String",
          label: "Tên chức vụ",
          filter: { type: "input", match: "contains" },
        },

        ordinal: {
          name: "ordinal",
          type: "Number",
          label: "Thứ tự hiển thị",
          class: "center"
        },

        active: {
          name: "active",
          type: "Boolean",
          label: "Hiển thị",
          class: "center"
        },

        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },

        deleted: {
          name: "deleted",
          label: "Xóa",
          type: "Checkbox",
          display: false,
        },
      }
    );
  }
}
